import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiLogin, apiMe } from '../api';
import type { User } from '../types';

export default function Login({ onLoggedIn }: { onLoggedIn: (u: User) => void }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const loc = useLocation();

  // 若剛從 /verify 拿到 cookie 回來,順手刷新一次 /api/me 讓 app state 同步
  useEffect(() => {
    apiMe().then(r => {
      if (r.user) onLoggedIn(r.user);
    });
  }, [onLoggedIn]);

  const urlError = new URLSearchParams(loc.search).get('error');
  const ERROR_MSG: Record<string, string> = {
    missing_token: '連結無效',
    invalid_or_expired: '連結無效或已過期',
    link_already_used: '此連結已被使用過,請向管理員索取新連結',
  };

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await apiLogin(email);
      setSent(true);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="login-shell">
      <div className="card login-card">
        <h2>登入</h2>
        <p className="muted small login-intro">
          請向管理員索取登入連結。
        </p>

        {urlError && (
          <div className="error">登入失敗:{ERROR_MSG[urlError] ?? urlError}</div>
        )}

        {/* 一般情況走 admin 從「管理 → 使用者」幫人產連結。這個表單只供
            admin 在尚未登入時自行 bootstrap — 點開後輸入信箱,連結會印
            到伺服器日誌(需具備 server console 存取權)。 */}
        <details className="admin-login">
          <summary>我是管理員</summary>
          {sent ? (
            <div className="login-sent">
              <p>若該信箱有效,登入連結已產生。</p>
              <button
                type="button"
                className="linkish"
                onClick={() => setSent(false)}
              >
                ← 重新輸入
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="login-form">
              <label>
                電子郵件
                <input
                  type="email"
                  required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </label>
              <button type="submit" className="primary">
                寄送登入連結
              </button>
              {error && <div className="error">{error}</div>}
            </form>
          )}
        </details>
      </div>
    </div>
  );
}
